// Global navigation reference for redirecting to login screen
// This will be set by the navigation container
type NavigationRefType = {
  navigate: (name: string, params?: any) => void;
  reset: (state: { index: number; routes: any[] }) => void;
  isReady: () => boolean;
};

let navigationRef: NavigationRefType | null = null;

export const setNavigationRef = (ref: NavigationRefType): void => {
  navigationRef = ref;
};

export const getNavigationRef = (): NavigationRefType | null => navigationRef;
